module.exports = __webpack_public_path__ + "img/service-05.89925d87.jpg";